import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors.ts';
import { GET_EVENT_SESSIONS_QUERY_KEY } from '@/state/queries/sessions/use-event-sessions.ts';
import { GET_EVENT_FILTERED_SESSIONS_QUERY_KEY } from '@/state/queries/sessions/use-filtered-event-sessions.ts';
import type { ContributorDto } from '@/types/dtos/contributors/response/contributor.dto.ts';

export const useMarkProfileReviewedMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (contributorId: string) => {
      const token = await getToken();
      return markProfileReviewed(contributorId, token ?? '');
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_SESSIONS_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_FILTERED_SESSIONS_QUERY_KEY] }),
      ]);
    },
  });
};

const markProfileReviewed = async (contributorId: string, token: string): Promise<ContributorDto> => {
  const url = `${import.meta.env.VITE_API_URL}/contributors/${contributorId}/mark-profile-reviewed`;
  return sendJSONRequest({ url, method: METHOD.POST, token });
};
